var _circle, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssessmentAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 58.5,
    r: 57.5,
    fill: "white",
    stroke: "url(#paint0_linear_1850_3974)",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1850_3974",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 113,
    height: 113
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 58.5,
    r: 56.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1850_3974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1012 88.6243C51.1012 85.4743 51.4112 74.1143 51.4112 74.1143C51.4112 74.1143 66.3712 72.4643 67.0112 74.4643C67.6512 76.4643 69.9012 88.8043 72.0512 90.1943C74.2012 91.5843 86.6812 93.5843 89.1412 96.1943C91.6012 98.8043 93.9312 103.974 94.1412 115.344L67.0112 122.5L41 119.5L25.8912 108.404C25.8112 99.4343 34.5411 95.6143 38.4311 95.2043C42.3211 94.7943 49.1012 91.7743 50.1012 88.6243Z",
    fill: "#9D663E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.974 23.2736C52.974 23.2736 45.974 17.5836 44.974 20.0036C43.974 22.4236 48.684 25.0036 48.684 25.0036C48.684 25.0036 37.414 22.2036 36.374 24.3536C35.334 26.5036 38.734 28.6436 38.734 28.6436C38.734 28.6436 31.334 29.1136 31.454 31.0636C31.4527 31.5808 31.5745 32.0908 31.8092 32.5516C32.0439 33.0123 32.3849 33.4107 32.804 33.7136C32.804 33.7136 23.394 35.6236 24.064 37.9336C24.734 40.2436 27.484 40.3236 27.484 40.3236C27.484 40.3236 20.814 43.8136 21.004 47.1336C21.124 49.3436 24.594 51.0836 25.224 51.9436C25.224 51.9436 17.884 57.5037 22.984 61.8736C28.084 66.2436 31.554 65.2436 31.554 65.2436C31.554 65.2436 28.224 68.2436 30.854 70.6336C33.484 73.0236 34.924 71.0337 34.924 71.0337C34.924 71.0337 34.574 75.7536 36.564 76.2736C38.554 76.7936 41.224 73.6336 41.224 73.6336C41.224 73.6336 41.614 77.6336 44.484 77.7236C45.2676 77.7823 46.0543 77.6594 46.7827 77.3646C47.5111 77.0698 48.1618 76.6109 48.684 76.0236C48.684 76.0236 49.884 78.4237 51.304 78.2037C52.1686 78.0604 52.9644 77.6433 53.574 77.0136C53.574 77.0136 58.214 80.1137 62.574 78.9237C66.934 77.7337 67.774 76.6236 67.774 76.6236C67.774 76.6236 72.544 77.7636 74.054 76.8836C74.9739 76.3417 75.8094 75.6679 76.534 74.8836C77.0968 75.3965 77.8118 75.7112 78.5701 75.7798C79.3284 75.8484 80.0883 75.6671 80.734 75.2636C82.994 73.8237 82.634 70.3137 82.634 70.3137C82.634 70.3137 85.234 72.1136 86.394 69.9436C86.7393 69.4261 86.9682 68.8398 87.0649 68.2251C87.1616 67.6105 87.1238 66.9822 86.954 66.3836C86.954 66.3836 91.594 67.5236 92.634 65.3836C93.674 63.2436 90.504 60.6936 90.504 60.6936C90.8428 60.9106 91.2254 61.0497 91.6245 61.1009C92.0235 61.1521 92.4289 61.1142 92.8115 60.9898C93.1941 60.8655 93.5444 60.6578 93.837 60.3818C94.1297 60.1058 94.3575 59.7683 94.504 59.3936C95.894 56.5636 92.804 51.1536 92.804 51.1536C92.804 51.1536 96.114 51.8536 96.444 48.9636C96.5023 48.0341 96.353 47.1032 96.0071 46.2384C95.6612 45.3736 95.1273 44.5966 94.444 43.9636C94.444 43.9636 98.084 43.7236 96.714 40.6836C95.344 37.6436 91.474 36.3236 91.474 36.3236C91.474 36.3236 93.474 32.8036 91.304 29.5436C89.134 26.2836 80.704 27.0936 80.704 27.0936C80.704 27.0936 85.564 25.4736 82.704 23.3136C79.844 21.1536 72.264 23.2036 72.264 23.2036C72.264 23.2036 74.044 20.4736 70.124 20.4636C66.204 20.4536 64.354 22.0036 64.354 22.0036C64.354 22.0036 67.544 16.8436 63.354 17.0036C59.164 17.1636 55.214 22.3536 55.214 22.3536C55.214 22.3536 54.214 19.0236 53.214 20.1236C52.214 21.2236 52.974 23.2736 52.974 23.2736Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.533 78.9033L50.293 86.7133L51.423 74.1133L62.533 78.9033Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2225 39.0241C52.3251 41.4894 51.2282 43.8773 49.9425 46.1641C48.397 48.635 46.2985 50.713 43.8125 52.2341C43.8125 52.2341 45.5325 66.1241 46.4125 68.4641C47.7925 72.2541 50.1225 77.1341 53.1525 79.7441C55.4025 81.6941 60.2225 84.3041 63.5225 82.4741C70.1425 78.8041 73.2725 71.7441 74.0125 64.4741C74.3525 61.1241 73.9025 49.7941 73.9025 49.7941C73.9025 49.7941 70.5825 47.6441 69.6525 46.0441C69.1784 45.2686 68.7542 44.4637 68.3825 43.6341C68.3825 43.6341 67.2625 45.5041 66.1125 44.8841C64.9625 44.2641 59.9425 37.2441 59.9425 37.2441C59.9425 37.2441 56.7825 42.0141 55.3125 42.9441C53.8425 43.8741 53.2225 39.0241 53.2225 39.0241Z",
    fill: "#9B643D",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6488 54.9523C61.4505 55.0344 61.2859 55.1634 61.1766 55.3224C61.0673 55.4814 61.0186 55.6628 61.0368 55.8427C61.1665 57.2219 61.6005 60.4928 62.8022 61.003C64.3295 61.6489 71.2981 61.8093 72.9303 60.7974C73.7916 60.2612 75.4847 55.8822 74.6732 54.7081C73.8618 53.5341 67.4812 52.6131 61.6488 54.9523Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0233 55.1561C58.2295 55.2154 58.4076 55.3252 58.534 55.4709C58.6604 55.6166 58.7292 55.7914 58.7312 55.9722C58.757 57.3574 58.6922 60.6562 57.5553 61.2979C56.11 62.1109 49.2033 63.0512 47.468 62.2287C46.552 61.7923 44.3787 57.6306 45.0535 56.373C45.7283 55.1154 51.9655 53.4853 58.0233 55.1561Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1374 54.8753C62.1374 54.8753 59.343 55.0323 57.5293 55.1343",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0414 55.9384L58.7373 56.0679",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8226 59.3729C44.8226 59.3729 41.8226 55.8229 40.7426 58.3729C39.6626 60.9229 41.5026 63.7229 42.5526 65.0429C43.4999 65.9496 44.6989 66.5491 45.9926 66.7629L44.8226 59.3729Z",
    fill: "#9B643D",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2503 57.1729C74.2503 57.1729 76.4703 53.6129 77.8703 56.0129C79.2703 58.4129 77.8003 61.4229 76.9203 62.8629C76.2029 63.8448 75.2114 64.5928 74.0703 65.0129L74.2503 57.1729Z",
    fill: "#9B643D",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5312 64.9737C57.3993 65.9298 58.5875 66.5346 59.8712 66.6738C60.6032 66.7237 61.3355 66.581 61.9952 66.2599C62.6549 65.9389 63.219 65.4506 63.6313 64.8438",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.543 69.553C54.543 69.553 59.803 75.053 66.373 68.793",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5432 56.4662C54.6549 56.4326 55.531 56.8716 55.5916 57.4639C55.6522 58.0562 54.7253 58.5561 53.6036 58.5893C52.4819 58.6225 51.6162 58.1739 51.5552 57.5916C51.4943 57.0093 52.4115 56.4991 53.5432 56.4662Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5784 57.8112C64.4765 57.967 63.5598 57.609 63.4396 57.0258C63.3194 56.4427 64.1916 55.8616 65.3035 55.7051C66.4154 55.5486 67.3228 55.9173 67.443 56.5004C67.5632 57.0836 66.6796 57.6454 65.5784 57.8112Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1133 54.2938C49.1133 54.2938 50.5033 51.1138 55.6833 52.1638",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7109 51.6734C61.7109 51.6734 65.941 49.5934 68.881 52.2834",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1012 88.6238C51.1012 85.4738 60 100.5 60 100.5C60 100.5 62.5 117.5 64.5 100.5C65.14 102.5 69.9012 88.8038 72.0512 90.1938C74.2012 91.5838 86.6812 93.5838 89.1412 96.1938C91.6012 98.8038 93.9312 103.974 94.1412 115.344L89.1412 116.672L28.5 118L25.8912 108.404C25.8112 99.4338 34.5411 95.6138 38.4311 95.2038C42.3211 94.7938 49.1012 91.7738 50.1012 88.6238Z",
    fill: "#5E06B9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1850_3974",
    x1: 25,
    y1: 10.5,
    x2: 101,
    y2: 97.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A25F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9AF9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentAvatarIcon);
export default __webpack_public_path__ + "static/media/AssessmentAvatarIcon.bdf88765746210400a9ccb68ba476b4f.svg";
export { ForwardRef as ReactComponent };